/**
 * Shown while a route is redirecting the user elsewhere (e.g. resolving a
 * short link to its real destination), so there's no blank frame between
 * mount and the redirect's navigate() call.
 */
export function RedirectPlaceholder() {
  return <div>
    <div className='spinner-border' aria-hidden='true' />
    <div role='status'>Please wait while we redirect you...</div>
  </div>
}
